import React from 'react';

interface IProps {
  className?: string;
  onClick?: () => void;
}

function BarIcon(props: IProps): JSX.Element {
  return <div {...props}>
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.75 13.75L1.75 7.75L7.75 1.75"
        stroke="#26237C"
        strokeWidth="2.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
}

export default BarIcon;
